/* eslint-disable max-len */
import React, { useEffect, useState, Suspense, useContext } from 'react';
import CardHeader from '../../../../components/CardHeader';
import TopBarWithShadow from '../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../components/CustomOverlay';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import { dataService } from '../../../../services/data.services';
import GlobalContext from '../../../../components/Context/GloablContext'
import moment from "moment";

// const ItemsTable = React.lazy(() => import('./components/ItemsTable'));
import ItemsTable from './components/ItemsTable';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';


const LedgerDetails = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [viewLedgerDetails, setViewLedgerDetails] = useState({})
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext);

    const getViewLedgerDetails = async () =>{
        try {
            const branch_id = await GetBranchId();
            let ledgerDetailsId = encodeURIComponent(id)
            setLoading(true)
            let endpoint = `groups-and-ledgers/details?_id=${ledgerDetailsId}&branch_id=${branch_id}`;
            console.log('Fetching data from:', endpoint);
            const response = await dataService.GetAPI(endpoint)
            console.log('Response:', response);
            const temp = response?.data?.data?.data
            setViewLedgerDetails(temp);
        } catch(error) {
            navigate('/404')
            console.log(error)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }
    console.log(viewLedgerDetails);
    
    useEffect(() => {
        getViewLedgerDetails();
    }, []);

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="Ledger Details"
                isback={true}
                backLocation={`/main-hub/groups-ledgers/?${searchParams.toString()}`}
            />
            <Suspense fallback={<CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />}>
                {loading ? (
                    <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />
                ) : (
                    <div className="mainDataCntnrPageDiv scrollBlue_thick">
                        <div className="border rounded border-[#D0D5DD] p-4 mb-4 2xl:w-[70%] xl:w-[90%] m-auto">
                            <div className=" w-full">
                                <div className="flex justify-between">
                                    {/* Ledger Name + Status */}
                                    <div className="w-[60%]  px-2 pr-3">
                                        <div className='flex mb-4'>
                                            <span className="min-w-[120px]">Ledger Name</span>
                                            <span className="font-semibold mr-3">{viewLedgerDetails.ledger_name || '-'}</span>
                                            {/* Status Badge */}
                                            <div
                                                className={`rounded ${
                                                    viewLedgerDetails?.status === 'active'
                                                        ? 'bg-[#C5FFD5]'
                                                        : viewLedgerDetails?.status === 'inactive'
                                                            ? 'bg-[#E6E8EA]'
                                                            : 'bg-[#FFEEB0]'
                                                } flex items-center justify-center ml-2 py-1 px-2.5`}
                                            >
                                                <img
                                                    loading="lazy"
                                                    decoding="async"
                                                    src={
                                                        viewLedgerDetails?.status === 'active'
                                                            ? '/images/successDot.svg'
                                                            : viewLedgerDetails?.status === 'inactive'
                                                                ? '/images/inactive-Dot.svg'
                                                                : '/images/draft-img.svg'
                                                    }
                                                    alt="icon"
                                                />
                                                <span className="text-f7 font-normal text-[#031624] pl-1">
                                                    {viewLedgerDetails?.status === 'active'
                                                        ? 'Active'
                                                        : viewLedgerDetails?.status === 'inactive'
                                                            ? 'Inactive'
                                                            : 'Draft'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className='flex  mb-4'>
                                            <span className="min-w-[120px]">Group</span>
                                            <span className="font-semibold w-[320px] ">{viewLedgerDetails?.parent_group?.parent_group_name || "-"}</span>
                                        </div>
                                        <div className='flex align-top'>
                                            <div className="flex mb-2">
                                                <span className="min-w-[120px] ">Description</span>
                                                <span className="font-semibold text-left w-[50%] pr-10 ">{viewLedgerDetails.description || ' -'}</span>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div className="w-[40%]  px-2 pl-3">
                                        {/* Opening Balance */}
                                        <div className="flex">
                                            <span className="text-left min-w-[160px]  mb-4">Opening Balance</span>
                                            <span className="font-semibold text-left ">
                                                {viewLedgerDetails.opening_balance === '0.00' &&
                                                    viewLedgerDetails.opening_balance_type === ''
                                                    ? '-'
                                                    : viewLedgerDetails.opening_balance}
                                            </span>
                                        </div>
                                        <div className='flex'>
                                            <span className="text-left min-w-[160px]  mb-4">Debit/Credit</span>
                                            <span className="font-semibold text-left ">{viewLedgerDetails?.opening_balance_type || "-"}</span>
                                        </div>
                                        <hr></hr>
                                        <div className='w-full justify-end mt-4'>
                                            <div className='text-left '>
                                                <div className="flex gap-1 ">
                                                    <span className="text-left ">Created on</span>
                                                    <span className="text-left">  {viewLedgerDetails.created_at ? `${moment(viewLedgerDetails.created_at).format('MMM DD, YYYY')} by ${viewLedgerDetails.created_by}` : '-'}</span>
                                                </div>
                                                
                                                {viewLedgerDetails.activated_at != null && <><div className="flex gap-1 mt-4">
                                                    <span className="text-left">Activated on</span>
                                                    <span className="text-left">{viewLedgerDetails.activated_at ? `${moment(viewLedgerDetails.activated_at).format('MMM DD, YYYY')} by ${viewLedgerDetails.activated_by}` : '-'}</span>
                                                </div></>}
                                                {viewLedgerDetails.status === 'inactive' && <><div className="flex gap-1 mt-4">                                                        <span className="text-left">Deactivated on</span>
                                                    <span className="text-left">{viewLedgerDetails.updated_at? `${moment(viewLedgerDetails.updated_at).format('MMM DD, YYYY')} by ${viewLedgerDetails.updated_by?.trim()? viewLedgerDetails.updated_by: viewLedgerDetails.activated_by?.trim()? viewLedgerDetails.activated_by: viewLedgerDetails.created_by}`: '-'}</span>
                                                </div></>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(
                            (
                                viewLedgerDetails.parent_group_type === 'Sundry Creditors' ||
                                viewLedgerDetails.parent_group_type === 'Sundry Debtors' ||
                                viewLedgerDetails.parent_group_type === 'Bank Accounts' ||
                                viewLedgerDetails.parent_group_type === 'Bank OD Account'
                            ) &&
                            viewLedgerDetails?.is_scheme_ledger === false &&
                            viewLedgerDetails?.is_autocreated === false
                        ) && (<>
                            <div className='2xl:w-[70%] xl:w-[90%] m-auto flex flex-col' style={{ marginTop: '30px' }}>
                                <div className="mb-2">
                                    {viewLedgerDetails?.parent_group_type === 'Bank Accounts' || viewLedgerDetails?.parent_group_type === 'Bank OD Account' ? <h1 className="font-semibold text-lg">Bank Account Details</h1> : <h1 className="font-semibold text-lg">Debtor Details</h1>}
                                </div>
                                <div className="border rounded border-[#D0D5DD] p-4">
                                    <div className=" w-full">
                                        {viewLedgerDetails.parent_group_type !== 'Bank Accounts' && viewLedgerDetails.parent_group_type !== 'Bank OD Account' &&
                                            <>
                                                <div className="flex mb-4 gap-4">
                                                    <div className='flex flex-row justify-between w-full'>
                                                        <div className='flex w-1/2 '>
                                                            <span className="w-[150px] ">PAN</span>
                                                            <span className="font-semibold text-left ">{viewLedgerDetails.pan_number || "-"}</span>
                                                        </div>
                                                        <div className='flex w-1/2 '>
                                                            <span className="min-w-[160px]">Billing Address</span>
                                                            <span className="font-semibold w-[200px] text-left ">{viewLedgerDetails.address || "-"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex mb-4 w-1/2 ">
                                                    <span className="w-[150px]">GSTIN</span>
                                                    <span className="font-semibold ">{viewLedgerDetails.gst_number || "-"}</span>
                                                </div>
                                                <div className="w-full border-t border-[#D0D5DD]  my-4"></div>
                                            </>
                                        }
                                        <div className="flex mb-4 w-full justify-between">
                                            <div className='flex items-start w-1/2 '>
                                                <span className="w-[150px]">Acc. Holder Name</span>
                                                <span className="font-semibold ">{ viewLedgerDetails.account_holder_name || "-"}</span>
                                            </div>
                                            <div className='flex  w-1/2'>
                                                <span className="min-w-[160px]">Bank Name</span>
                                                <span className="font-semibold w-[200px] text-left ">{ viewLedgerDetails.bank_name || "-"}</span>
                                            </div>
                                        </div>
                                        {(viewLedgerDetails.parent_group_type === 'Bank Accountsss' || viewLedgerDetails.parent_group_type === 'Bank OD Account') ? (
                                            <div className="flex mb-4 justify-between">
                                                <div className='flex items-start w-1/2'>
                                                    <span className="w-[150px]">Account No.</span>
                                                    <span className="font-semibold ">{viewLedgerDetails.account_number || "-"}</span>
                                                </div>
                                                <div className='flex w-1/2 '>
                                                    <span className="min-w-[160px]">Branch Name</span>
                                                    <span className="font-semibold w-[200px] text-left">{viewLedgerDetails.branch_name || "-"}</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex mb-4 justify-between">
                                                <div className='flex items-start w-1/2 '>
                                                    <span className="w-[150px]">Account No.</span>
                                                    <span className="font-semibold ">{viewLedgerDetails.account_number || "-"}</span>
                                                </div>
                                                <div className='flex w-1/2 '>
                                                    <span className="min-w-[160px]">Branch Name</span>
                                                    <span className="font-semibold w-[200px] text-left ">{viewLedgerDetails.branch_name || "-"}</span>
                                                </div>
                                            </div>
                                        )}

                                        {(viewLedgerDetails.parent_group_type === 'Bank Accounts' || viewLedgerDetails.parent_group_type === 'Bank OD Account') && <>
                                            <div className="flex mb-4 gap-4 justify-between">
                                                <div className='flex items-start '>
                                                    <span className="w-[150px]">Account Type</span>
                                                    <span className="font-semibold ">{ viewLedgerDetails.account_type|| "-"}</span>
                                                </div>
                                                <div className='flex  w-1/2 '>
                                                    <span className=" min-w-[160px]">IFSC Code</span>
                                                    <span className="font-semibold w-[200px] text-left ">{ viewLedgerDetails.ifsc_code|| "-"}</span>
                                                </div>
                                            </div>
                                        </>
                                        }   
                                        <div className="flex">
                                            <div className=' w-1/2 '>
                                                <span className="w-[140px]"></span>
                                                <span className="font-semibold "></span>
                                            </div>
                                            <div className='w-1/2 flex '>
                                                <span className="min-w-[160px]">Swift Transfer Code</span>
                                                <span className="font-semibold w-[200px] text-left ">{ viewLedgerDetails.swift_transfer_code|| "-"}</span>                                    </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </>)}
                    </div>
                )}
            </Suspense>
        </CardHeader>
    );
};

export default LedgerDetails;











